<template>
  <div class="goods-detail-wrapper"  v-if="token">
    <div class="swiper-wrapper" v-show="detailData.image&&detailData.image.length>0||(detailData.video&&detailData.video.url)">
      <van-swipe
        ref="s_b"
        :width="swipeWidth"
        class="swiper-container"
        :show-indicators="false"
        @change="onSwipeChange"
      >
        <van-swipe-item v-if="detailData.video&&detailData.video.url" id="J_prismPlayer" class="blur-wrapper">
        </van-swipe-item>
        <van-swipe-item v-for="(image,index) in detailData.image" :key="index">
            <img :src="`${image.url}?x-oss-process=image/resize,w_${swipeWidth}`" />
        </van-swipe-item>
        <template slot="indicator" v-if="!needshowVideo||!(detailData.video&&detailData.video.url)">
            <div class="custom-indicator">{{ (detailData.video&&detailData.video.url)?currentSwipe:currentSwipe+1 }}/{{detailData.image&&detailData.image.length}}</div>
        </template>
      </van-swipe>
      <div class="change-btn-wrapper"  v-show="detailData.video&&detailData.video.url">
        <div class="change-btn">
            <span class="video-btn" :class="needshowVideo?'active-btn':'deactive-btn'" @click.stop="showVideo">视频</span>
            <span class="pic-btn"   :class="!needshowVideo?'active-btn':'deactive-btn'" @click.stop="showPic">图片</span>
        </div>
    </div>
    </div>
    <div class="goods-introduction">
      <div class="goods-title" v-text="detailData.name"></div>
      <div :class="hasStandard?'price-wra':'price-wra-active'">
        <span class="price">
          ￥
          <span class="number">{{currentSpec.salePrice}}</span>
        </span>
      </div>
      <div class="standard" v-if="hasStandard">
        <div class="standard-title">规格</div>
        <div class="standard-det">
          <span
            class="standard-detail"
            v-text="item.name"
            v-for="item in detailData.specs"
            :key="item.id"
            :class="{active:currentSpec.id === item.id}"
            @click="changeSpec(item)"
          ></span>
        </div>
      </div>
    </div>
    <div class="detail-zone">
      <div class="commnet-wra" v-cloak v-if="detailData.score">
        <span class="commnet">
          <span class="suffix">{{detailData.score}}</span>
          <star-orange :score="detailData.score"></star-orange>
        </span>
        <div class="more-comment" @click="redirectToComment">
          <span>{{detailData.commentNum}}条评论</span>
          <img :src="grayRightArrowSrc" alt>
        </div>
      </div>

      <div class="first-comment" v-if="detailData.commentNum>0">
        <div class="flex-wra">
          <img :src="firstComment.profile || defaultUser.avatar" alt="avatar-image" class="avatar">
          <div class="mid-lane">
            <div class="user-name text-overflow" v-text="firstComment.userName || defaultUser.name"></div>
          </div>
        </div>
        <div class="content" v-text="firstComment.content"></div>
      </div>
      <div ref="slide" v-if="detailData.introduction">
        <div :style="style" class="goods-detail-title">
          <div class="detail-title">
            商品详情
            <div class="activeSlider"></div>
          </div>
        </div>
        <div class="goods-detail rich-context-wra protect-image" v-html="detailData.introduction"></div>
      </div>
    </div>
    <div class="cart-wrapper">
      <div class="img-wra" @click="redirectToWenChuangCart">
        <img :src="cartIconSrc" alt="cart" class="cart">
        <div class="badge" v-text="cartTotalNumber" v-if="cartTotalNumber"></div>
      </div>
      <div class="btn-group">
        <div class="add-cart each-btn" @click="addCart">加入购物车</div>
        <div class="bug-icon each-btn" @click="toBuy">立即购买</div>
      </div>
    </div>
    <coupon-modal
      type="receive"
      :data="coupons"
      @receive:success="receiveCouponSuccess"
      ref="couponmodal"
    ></coupon-modal>
    <page-guide></page-guide>
  </div>
</template>

<script>
import { _auth } from "@/js/auth";
import CouponTag from "@/components/common/CouponTag";
import CouponModal from "@/components/CouponModal";
import StarOrange from "@/components/common/StarOrange";
import PageGuide from "@/components/common/PageGuide";
export default {
  name: "WenChuangDetail",
  components: { CouponTag, CouponModal, StarOrange ,PageGuide },
  props: {
    // layouts: String,
    // layoutType: String,
  },
  data() {
    return {
      defaultUser: {
        avatar: API.ossUrl + "common/empty_icons/noimage-1-1.png?param=1",
        name: "未知用户"
      },
      currentSwipe: 0,
      currentSpec: {},
      cartTotalNumber: 0,
      detailData: {},
      coupons: [],
      swipeWidth: window.innerWidth,
      isWXSharePage: true,
      cartIconSrc: "",
      rightGrayArrowSrc: "",
      hasStandard: false,
      style: {},
      token: sessionStorage.getItem("token") || "",
      currentSwipe: 0,
      needshowVideo:  true,
      showVideoImg: true,
      player: null,
    };
  },
  computed: {
    ossResolvedAvatar() {
      if (!this.firstComment.profile || this.firstComment.profile === "0")
        return "";
      return (
        `${this.firstComment.profile}?x-oss-process=image/resize,h_300` || ""
      );
    },
    firstComment() {
      return this.detailData.comment ? this.detailData.comment[0] : {};
    },
    validCoupons() {
      return this.coupons.filter(coupon => coupon.isDraw === 0);
    }
  },
  watch: {},
  activated() {
    this.isWXSharePage = true;
    this.getGoodsDetailData();
    if (this.token) {
        this.getCartNumber();
    } else {
        _auth(this, () => {
            this.getCartNumber();
        });
    }
    this.hasStandard = false;
    this.goToTop();
  },
  deactivated() {
    this.isWXSharePage = false;
    this.$refs.couponmodal.closeModal();
    this.detailData = {};
    this.currentSwipe = 0;
    if(this.player){
        this.player.dispose();
        this.player = null;
    }
  },
  mounted() {
    this.cartIconSrc = API.ossUrl + "goods/png/cart-icon.png";
    this.grayRightArrowSrc = API.ossUrl + "home/png/gray-right-arrow.png";
    this.goToTop();
  },
  destroyed() {},
  methods: {
    showVideo(){
        this.needshowVideo = true;
        this.$refs.s_b.swipeTo(0);
    },
    showPic(){
        this.needshowVideo = false;
        this.$refs.s_b.swipeTo(1);
    },
    onSwipeChange(index) {
        this.currentSwipe = index;
        this.currentSwipe == 0 ? this.needshowVideo = true: this.needshowVideo = false;
        this.currentSwipe == 0 ? this.showVideoImg = true: false; 
        if(this.currentSwipe != 0&&this.player){
            this.player.pause();
        } 
    },
    goToTop() {
      let vm = this;
      window.onscroll = function() {
        var div = vm.$refs.slide;
        if (!div) {
          return;
        }
        if (sessionStorage.getItem("onscroll") !== "wenChuangDetail") {
          vm.style = {};
          return;
        }
        if (div.getBoundingClientRect().top <= 10) {
          vm.style = {
            position: "fixed",
            top: 0,
            "background-color": "#fff",
            "z-index": 100,
            width: "100%",
            "margin-left": "-0.32rem"
          };
          vm.styleFlag = true;
        } else {
          vm.style = {};
          vm.styleFlag = false;
        }
      };
    },
    changeSpec(spec) {
      this.currentSpec = spec;
    },
    openCouponModal() {
      this.$refs.couponmodal.openModal();
    },
    redirectToComment() {
      if (this.detailData.commentNum == 0) {
        return;
      }
      this.$router.push(
        `/WenChuangComment?id=${this.detailData.id}&specsId=${this.currentSpec.id}`
      );
    },
    redirectToWenChuangCart() {
      this.$router.push({ name: "wenChuangCart" });
    },
    getCartNumber() {
      this.$axios
        .get(`${window.API.goods.listCart}?token=${sessionStorage.token}`)
        .then(({ data }) => {
          if (data.code == 200) {
            this.cartTotalNumber = data.data.filter(e => {
              return e.isEnabled != 0;
            }).length;
          }
        });
    },
    addCart() {
      this.$axios
        .post(`${window.API.goods.addCart}?token=${sessionStorage.token}`, {
          specs_id: Number(this.currentSpec.id) || 0,
          product_id: Number(this.$route.params.wenChuangId),
          quantity: 1
        })
        .then(({ data }) => {
          if (data.code == 200) {
            this.$toast("添加到购物车成功！");
            this.getCartNumber();
          } else {
            this.$toast(data.msg);
          }
        })
        .catch(err => console.log(err));
    },
    toBuy() {
      //把商品specs_id存上
      sessionStorage.goodsIdList = this.currentSpec.id;
      this.$router.push({
        name: "wenChuangOrder",
        params: {
          type: 0
        }
      });
    },
    getGoodsDetailData() {
      this.$axios
        .get(`${window.API.goods.detail}/${this.$route.params.wenChuangId}`)
        .then(({ data }) => {
          if (data.code == 200) {
            let specs = data.data.specs;
            this.detailData = data.data;
            if(this.detailData.video&&this.detailData.video.url){
                let videoUrl = this.detailData.video.url;
                let coverImg = `${this.detailData.video.url}?x-oss-process=video/snapshot,t_2000,f_jpg,w_500,h_300` 
                this.$nextTick(()=>{ 
                    this.player = new Aliplayer({
                        id: "J_prismPlayer", // 容器id
                        source: videoUrl,  //视频地址
                        cover: coverImg,  //播放器封面图
                        autoplay: false,      // 是否自动播放
                        width: "100%",       // 播放器宽度
                        height: "750px",      // 播放器高度
                        playsinline: true,
                        seekable: true,
                        skinLayout: [{
                            "name": "bigPlayButton",
                            "align": "cc"
                            //"x": 30,
                            //"y": 80
                        }, {
                            "align": "blabs",
                            "x": 0,
                            "y": 10,
                            "name": "controlBar",
                            "children": [
                            {
                                "align": "tl",
                                "x": 15,
                                "y": 26,
                                "name": "playButton"
                            }, {
                                "align": "tl",
                                "x": 10,
                                "y": 24,
                                "name": "timeDisplay"
                            }, {
                                "align": "tr",
                                "x": 20,
                                "y": 25,
                                "name": "fullScreenButton"
                            }, {
                                "align": "tr",
                                "x": 20,
                                "y": 25,
                                "name": "volume"
                            },
                            {
                                "name": "progress",
                                "align": "tlabs",
                                "x": 0,
                                "y": 0
                            }
                            ]
                        }]
                    })
                })
            }   
            if (this.detailData.specs[0].name != "") {
              this.hasStandard = true;
            }
            //开启规格时 currentSpec为第一个规格 关闭时为默认最外层data中的规格
            // if (data.data.enableSpecs) {
            this.currentSpec = specs[0] || {};
            // } else {
            //     this.currentSpec = data.data;
            // }
            //设置微信分享
            if (
              this.isWXSharePage &&
              sessionStorage.getItem("title") !==
                `${API.projectName}-${data.data.name}`
            ) {
              this.isWXSharePage = false;
              window.global.getConfig({
                title: `${API.projectName}-${data.data.name}`,
                link: `${window.location.origin}?shareto=${
                  this.$route.name
                }&shareid=${this.$route.params.wenChuangId}`,
                imgUrl: `${
                  data.data.thumbimg
                    ? data.data.thumbimg +
                      "?x-oss-process=image/resize,m_fill,h_256,w_256"
                    : ""
                }`,
                desc: ``
              });
            }
          } else {
            this.$toast(data.msg);
          }
        })
        .catch(err => console.log(err));
    },
    getCouponsByGoodsID() {
      this.$axios
        .get(
          `${window.API.goods.coupon}/${this.$route.params.wenChuangId}?token=${
            sessionStorage.token
          }`
        )
        .then(({ data }) => {
          if (data.code == 200) {
            this.coupons = data.data;
          } else {
            this.$toast(data.msg);
          }
        })
        .catch(err => console.log(err));
    },
    receiveCouponSuccess(couponID) {
      this.getCouponsByGoodsID();
      // let index = this.coupons.findIndex(e => couponID == e.id);
      // this.$set(this.coupons[index], "isReceived", true);
    }
  }
};
</script>

<style scoped lang="scss">
.goods-detail-wrapper {
    padding-bottom: 4.666667rem;
  .swiper-wrapper {
    height: 100vw;
    .change-btn-wrapper {
        position: absolute;
        top: 9rem;
        left: 0;
        width: 100%;
        z-index: 100;
        .change-btn{
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .video-btn,
        .pic-btn {
            display: inline-block;
            line-height: 0.586667rem;
            font-size:0.293333rem;
            border-radius: 0.373333rem;
            text-align: center;
        }
        .video-btn{
            margin-right: 0.266667rem;
        }
        .active-btn{
            width:1.493333rem;
            height:0.586667rem;
            border: none;
            color: #ffffff;
            background: #ffbc00;
        }
        .deactive-btn{
            width: 1.44rem;
            height: 0.586667rem;
            background:rgba(255,255,255,1);
            border:0.026667rem solid rgba(202,202,202,0.8);
        }
    }
    .swiper-container {
      height: 100%;
      .blur-wrapper {
        position: relative;
        .video-play {
            position: absolute;
            top: 1.466667rem;
            left: 4.373333rem;
            z-index: 100;
            width: 1.28rem;
            height: 1.28rem;
        }
      }
    }
  }
  .goods-introduction {
    padding: 0.186667rem 0.373333rem 0.56rem 0.373333rem;
    margin: 0.5rem 0.533333rem 0 0.533333rem;
    box-shadow: 0px 4px 8px 4px rgba(174, 174, 174, 0.28);
    border-radius: 10px;
    position: relative;
    background: $white;
    z-index: 100;
    .goods-title {
      color: #444444;
      font-size: 0.533333rem;
      font-weight: bold;
      line-height: 0.746667rem;
    }
    .price-wra {
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgba(235, 235, 235, 1);
      line-height: 0.746667rem;
      margin-top: 0.106667rem;
      padding-bottom: 0.213333rem;
      margin-bottom: 0.213333rem;
      .price {
        font-size: 0.533333rem;
        color: #ff9200;
        .number {
          font-weight: bold;
        }
      }
    }
    .price-wra-active {
      border-bottom: 0px solid rgba(235, 235, 235, 1);
      .price {
        font-size: 0.533333rem;
        color: #ff9200;
        .number {
          font-weight: bold;
        }
      }
    }
  }
  .standard {
    margin-top: 0.32rem;
    .standard-title {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
    }
    .standard-det {
      margin-top: 0.2rem;
      .standard-detail {
        padding: 0 0.08rem;
        display: inline-block;
        line-height: 0.533333rem;
        background: #eeeeee;
        border-radius: 0.16rem;
        font-size: 12px;
        font-weight: 400;
        margin-right: 0.106667rem;
        margin-bottom: 0.133333rem;
        &.active {
          color: #f0bb1b;
          background: rgba(240, 187, 27, 0.1);
          border: 1px solid #f0bb1b;
          border-radius: 0.16rem;
        }
      }
    }
  }
}
.detail-zone {
  padding: 0.4rem;
  margin-bottom: 1.466666rem;
  .commnet-wra {
    display: flex;
    justify-content: space-between;
    .commnet {
      display: flex;
      align-items: center;
      font-size: 26px;
      color: #f8b356;
      line-height: 0.986667rem;
      .suffix {
        margin-right: 0.213333rem;
      }
    }
    .more-comment {
      font-size: 12px;
      color: #8c8c8c;
      img {
        margin-left: 0.213333rem;
        width: 0.373333rem;
        height: 0.373333rem;
      }
    }
  }
  .first-comment {
    border-radius: 5px;
    margin-top: 0.106667rem;
    margin-bottom: 0.56rem;
    .flex-wra {
      margin-bottom: 0.266667rem;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      .avatar {
        width: 1.066667rem;
        height: 1.066667rem;
        border-radius: 50%;
        margin-right: 0.266667rem;
      }
      .mid-lane {
        flex: 1 0 auto;
        max-width: 5.8rem;
        .user-name {
          font-size: 14px;
          font-weight: 500;
          line-height: 40px;
          color: #444444;
        }
      }
    }
    .content {
      font-size: 14px;
      font-weight: 400;
      line-height: 0.533333rem;
      color: #444444;
      @include multiple-text-overflow(2);
    }
  }
  .goods-detail-title {
    padding: 0.1334rem;
    .detail-title {
      margin: 0 auto;
      font-size: 0.426667rem;
      font-weight: bold;
      line-height: 0.586667rem;
      text-align: center;
      width: 1.806667rem;
      padding: 0.133333rem 0;
      .activeSlider {
        margin-top: 0.106667rem;
        width: 100%;
        height: 0.053333rem;
        background: rgba(240, 187, 27, 1);
        box-shadow: 0px 0px 0.106667rem 0px rgba(241, 188, 0, 0.6);
      }
    }
  }
  .goods-detail {
    margin-top: 0.466667rem;
  }
}
.more-comment {
  text-align: center;
  color: #6293cc;
  font-size: 15px;
  margin-bottom: 0.4rem;
  margin-top: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  .traingle {
    width: 0.146667rem;
    height: 0.2rem;
    margin-left: 0.16rem;
  }
}
.cart-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: $white;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.09);
  height: 1.466667rem;
  .img-wra {
    position: relative;
    margin-left: 0.466667rem;
    height: 100%;
    display: flex;
    align-items: center;
    .cart {
      width: 0.746667rem;
      height: 0.626667rem;
    }
    .badge {
      position: absolute;
      width: 28px;
      height: 28px;
      right: -12px;
      top: 7px;
      z-index: 10;
      color: $white;
      background: $orange;
      border-radius: 50%;
      font-size: 0.533333rem;
      display: flex;
      justify-content: center;
      align-items: center;
      transform: scale(0.5);
    }
  }
  .btn-group {
    width: 5.066667rem;
    height: 1.066667rem;
    margin-right: 0.32rem;
    color: #f8b356;
    display: flex;
    overflow: hidden;
    .each-btn {
      background: $white;
      width: 50%;
      height: 1.066667rem;
      line-height: 1.066667rem;
      color: #f8b356;
      font-size: 14px;
      text-align: center;
      &.bug-icon {
        background: linear-gradient(
          90deg,
          rgba(248, 199, 64, 1) 0%,
          rgba(245, 149, 38, 1) 100%
        );
        color: $white;
        border: 1px solid transparent;
        border-left: 0 solid transparent;
        border-radius: 0 0.533333rem 0.533333rem 0;
      }
      &.add-cart {
        border: 1px solid rgba(248, 179, 86, 1);
        border-right: 0 solid transparent;
        border-radius: 0.533333rem 0 0 0.533333rem;
      }
    }
  }
}
</style>

